import {
  BROADCAST_SCENE_SYNC,
  BROADCAST_SCENE_TAKE_LIVE,
  BROADCAST_SET_SELECTED_SCENE,
  BROADCAST_GET_SCENES,
  BROADCAST_SCENE_CREATE,
  BROADCAST_SCENE_DELETE,
  BROADCAST_SCENE_DUPLICATE,
  BROADCAST_UPDATE_SCENE_DELETE_SOURCE_FROM_SCENE,
  BROADCAST_REPLACE_SOURCE_FROM_SCENE,
  BROADCAST_SCENE_UPDATE,
  BROADCAST_SCENES_UPDATE,
  BROADCAST_SCENE_ORDER_UPDATE
} from 'actions/Types';
import { groupById } from 'utils/broadcastSourceHelper';

const initialState = {
  currentScene: null,
  sceneTakenToLive: null,
  scenesById: {},
  scenes: []
};

export default (state = initialState, action) => {
  const { payload } = action;
  if (BROADCAST_SCENE_UPDATE === action.type) {
    return {
      ...initialState,
      ...state,
      scenes: state.scenes.map(scene => {
        if (scene._id === action.payload._id) {
          return {
            ...scene,
            ...payload
          };
        }
        return scene;
      })
    };
  }

  if (`${BROADCAST_SCENES_UPDATE}_SUCCESS` === action.type) {
    const updatedScenesPayload = action.payload.scenes;
    const updatedScenes = state.scenes.map(scene => {
      const updatedScene = updatedScenesPayload.find(
        updatedScene => updatedScene._id === scene._id
      );
      return updatedScene ? { ...scene, ...updatedScene } : scene;
    });

    return {
      ...state,
      scenes: updatedScenes
    };
  }

  if (
    [
      `${BROADCAST_SCENE_SYNC}_SUCCESS`,
      `${BROADCAST_GET_SCENES}_SUCCESS`
    ].includes(action.type)
  ) {
    const scenes = payload.scenes || [];
    const scenesById = groupById(scenes);
    return {
      ...initialState,
      ...state,
      scenesById,
      scenes
    };
  }

  if (`${BROADCAST_SCENE_CREATE}_SUCCESS` === action.type) {
    const { scene } = action.payload;

    return {
      ...state,
      scenes: [...state.scenes, scene]
    };
  }

  if (`${BROADCAST_SET_SELECTED_SCENE}` === action.type) {
    return {
      ...state,
      currentScene: action.payload
    };
  }
  if (`${BROADCAST_SCENE_TAKE_LIVE}` === action.type) {
    return {
      ...state,
      sceneTakenToLive: action.payload,
      currentScene: action.payload
    };
  }

  if (`${BROADCAST_SCENE_DELETE}_SUCCESS` === action.type) {
    const { sceneId } = action.payload;

    const filteredScenes = state.scenes.filter(scene => scene._id !== sceneId);

    return {
      ...state,
      scenes: filteredScenes
    };
  }

  if (`${BROADCAST_SCENE_UPDATE}_SUCCESS` === action.type) {
    const { scene: updatedScene } = action.payload;
    const updatedScenes = state.scenes.map(scene => {
      if (scene._id === updatedScene._id) {
        return {
          ...updatedScene
        };
      }
      return scene;
    });

    return {
      ...state,
      scenes: updatedScenes
    };
  }

  if (
    [
      `${BROADCAST_SCENE_DUPLICATE}_SUCCESS`,
      `${BROADCAST_SCENE_ORDER_UPDATE}_SUCCESS`
    ].includes(action.type)
  ) {
    const { scenes } = action.payload;
    const updatedScenes = scenes.map(scene => {
      const sceneInState = state.scenes.find(s => s._id === scene._id);

      if (sceneInState) {
        return {
          ...sceneInState,
          ...scene
        };
      }

      return scene;
    });

    const sorted = updatedScenes.sort((a, b) => a.order - b.order);

    return {
      ...state,
      scenes: sorted
    };
  }

  if (
    [
      `${BROADCAST_UPDATE_SCENE_DELETE_SOURCE_FROM_SCENE}_SUCCESS`,
      `${BROADCAST_REPLACE_SOURCE_FROM_SCENE}_SUCCESS`
    ].includes(action.type)
  ) {
    const { scenes } = action.payload;
    const combinedScenes = state.scenes.map(scene => {
      const updatedScene = scenes.find(s => s._id === scene._id);
      if (updatedScene) {
        return {
          ...updatedScene
        };
      }
      return scene;
    });

    return {
      ...state,
      scenes: combinedScenes
    };
  }

  return state;
};
